<template>
  <b-form-group :label="label" class="d-inline-block mr-2" :style="style">
    <slot />
  </b-form-group>
</template>

<script>
	export default {
		name: 'ListControl',
    props: {
		  label: {
		    type: String,
        default: ""
      },
      width: {
		    type: String,
        default: "120px"
      }
    },

    computed: {
		  style() {
		    return {maxWidth: this.width};
      }
    }
	};
</script>

<style scoped>

</style>
